import { TBasketItem } from 'pages/common/types';

type TGetFilteredProductsForBasket = {
  basketArr: TBasketItem[];
  complimentaryProductInfoForBasket: TBasketItem[];
};

export const addComplimentaryProductsToBasketArr = ({
  basketArr,
  complimentaryProductInfoForBasket,
}: TGetFilteredProductsForBasket) =>
  basketArr.concat(complimentaryProductInfoForBasket).reduce((accumulator, current) => {
    const existingProduct = accumulator.find(item => item.code === current.code);

    if (existingProduct) {
      existingProduct.quantity += current.quantity;
    } else {
      accumulator.push({ ...current });
    }

    return accumulator;
  }, [] as TBasketItem[]);
